// The track inside the dashboard/dose_logs/_ruler drawing runs from x 6 to x 594.
const RULER_START = 6;
const RULER_WIDTH = 588;

export function placeRuler(ruler, drawn, capacity, label) {
  const marker = (RULER_START + RULER_WIDTH * Math.min(Math.max(drawn / capacity, 0), 1)).toFixed(1);
  ruler.querySelector('[data-ruler-part="fill"]').setAttribute("width", (marker - RULER_START).toFixed(1));
  const line = ruler.querySelector('[data-ruler-part="marker"]');
  line.setAttribute("x1", marker);
  line.setAttribute("x2", marker);
  ruler.setAttribute("aria-label", label);
}
